export class ServiceTypeModel {
    id: number;
    serviceTypeName: string;
    status: boolean;
    insertDate: any;
    insertUser: string;
    updateuser: string;
    updateDate: any;
    isExistId:boolean;
  }